/* eslint-disable @typescript-eslint/no-explicit-any */
import { Box, Grid, Typography, Button } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { useAppSelector } from '../../infra/hooks';
import React, { useState, ReactNode } from 'react';
import { fonts, themes } from '../../common/themes/themes';
import SearchComponent from '../../common/components/SearchComponent';
import _ from 'lodash';
import './toDoTask.css';

interface propToDoTask {
  trans: (value: any) => ReactNode;
  toDoTaskData: any;
  setToDoTaskIdForUpdate: (id: number, status: string) => void;
}
const ToDoTaskPresenter: React.FC<propToDoTask> = ({
  toDoTaskData,
  setToDoTaskIdForUpdate,
  trans,
}) => {
  const [pageSize, setPageSize] = React.useState<number>(10);
  const [textFilterToDoTask, setTextFilterToDoTask] = useState('');
  const isHRView = useAppSelector((state) => state.isHRViewSlice.HRView);

  const filterToDoTaskList = () => {
    if (textFilterToDoTask.length) {
      const txt = textFilterToDoTask.toLowerCase();
      const res = _.filter(toDoTaskData, function (e) {
        return (
          e.candidate_name?.toLowerCase().includes(txt) ||
          e.task_name?.toLowerCase().includes(txt) ||
          e.date_of_joining?.toLowerCase().includes(txt) ||
          e.task_type?.toLowerCase().includes(txt) ||
          e.remarks?.toLowerCase().includes(txt) ||
          e.status_text?.toLowerCase().includes(txt)
        );
      });

      {
        return res;
      }
    } else {

      return toDoTaskData;
    }
  };

  const handleGetTextFilter = (value: any) => {
    setTextFilterToDoTask(value);
  };

  const handleUpdateStatus = (id: number, status: string) => {
    setToDoTaskIdForUpdate(id, status);
  };

  const tableColumns: any = [
    {
      field: 'candidate_name',
      headerName: trans('Candidate Name'),
      width: 250,
      headerClassName: 'header',
      height: 90,
      flex: 1,
    },
    {
      field: 'date_of_joining',
      headerName: trans('Date of Joining'),
      headerClassName: 'header',
      height: 70,
      flex: 1,
    },
    {
      field: 'task_name',
      headerName: trans('Task'),
      width: 50,
      headerClassName: 'header',
      height: 90,
      flex: 1,
    },

    {
      field: 'remarks',
      headerName: trans('Remarks'),
      headerClassName: 'header',
      height: 70,
      flex: 1,
    },
    {
      field: 'task_type',
      headerName: trans('Task Type'),
      headerClassName: 'header',
      height: 70,
      flex: 1,
    },
    {
      field: 'status',
      headerName: trans('Status'),
      headerClassName: 'header',
      height: 70,
      flex: 1,
      renderCell: (params: any) => {
        return (
          <Typography
            className={_.lowerCase(params?.row?.status_text) + '-todo-status'}
          >
            {trans(params?.row?.status_text)}
          </Typography>
        );
      },
    },
    {
      field: 'id',
      headerName: trans('Action'),
      headerClassName: 'header',
      height: 70,
      flex: 1,
      renderCell: (params: any) => {
        return params?.row?.status === 0 ? (
          <>
            <Grid item>
              <Button
                className="approved-btn"
                onClick={() => handleUpdateStatus(params?.row?.id, 'approve')}
              >
                {trans('Approve')}
              </Button>
            </Grid>

            <Grid item>
              <Button
                className="rejected-btn"
                onClick={() => handleUpdateStatus(params?.row?.id, 'reject')}
              >
                {trans('Reject')}
              </Button>
            </Grid>
          </>
        ) : (
          <></>
        );
      },
    },
  ];

  return (
    <>
      <Grid
        container
        style={{
          display: 'flex',
          flexWrap: 'nowrap',
          marginTop: isHRView ? '' : '4em',
          width: '100vw',
          paddingRight: '8em',
        }}
      >
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          sx={{
            backgroundColor: '#F5F5FA',
            width: '100%',
            padding: '1.75em',
          }}
        >
          <Grid
            container
            style={{
              paddingLeft: isHRView ? '2em' : '',
            }}
          >
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              sx={{
                width: '100%',
                height: '80px',
              }}
            >
              <Grid
                container
                style={{
                  width: 'auto',
                  background: '#FFFFFF 0% 0% no-repeat padding-box',
                  borderRadius: '10px',
                  opacity: '1',
                  display: 'flex',
                  flexDirection: 'row',
                  paddingTop: '1em',
                  paddingBottom: '1em',
                  paddingLeft: '1em',
                  paddingRight: '1em',
                }}
              >
                <Grid item xs={9}>
                  <Typography
                    style={{
                      fontFamily: fonts.fontFamily,
                      fontSize: fonts.header,
                      color: themes.blackDefault,
                      fontWeight: 'bold',
                    }}
                  >
                    {trans('To-Do Tasks')}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              sx={{
                width: '100%',
              }}
            >
              <Grid
                container
                style={{
                  width: 'auto',
                  background: '#FFFFFF 0% 0% no-repeat padding-box',
                  borderRadius: '10px',
                  opacity: '1',
                  display: 'flex',
                  flexDirection: 'row',
                  paddingTop: '1em',
                  paddingBottom: '1em',
                  paddingLeft: '1em',
                  paddingRight: '1em',
                }}
              >
                <Grid item xs={12}>
                  <Box
                    sx={{
                      '& .header': {
                        backgroundColor: '#F5F5F5',
                      },
                    }}
                  >
                    <Grid container style={{ marginTop: '1em' }}>
                      <Grid item xs={12}>
                        <SearchComponent
                          onChange={handleGetTextFilter}
                          inputWidth={'30%'}
                        />
                        <Box style={{ maxHeight: '30em', overflowY: 'auto' }}>
                          <DataGrid
                            sx={{
                              fontSize: fonts.subtitle,
                              color: '#081735',
                              fontFamily: fonts.fontFamily,
                              marginTop: '1.5em',
                            }}
                            autoHeight
                            disableColumnMenu
                            pageSize={pageSize}
                            onPageSizeChange={(newPageSize) =>
                              setPageSize(newPageSize)
                            }
                            rowsPerPageOptions={[10]}
                            disableSelectionOnClick
                            rows={filterToDoTaskList()}
                            columns={tableColumns}
                          />
                        </Box>
                      </Grid>
                    </Grid>
                  </Box>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};
export default ToDoTaskPresenter;
